/**
 * @fileoverview GET handler for the "/integrations/direct/cdi/sources" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import type { RootCacheKey } from "../types";
import { integrationsDirectCdiSources } from "./constants";
import type { CDISource } from "./types";
import { isCdiSourcesResult } from "./validators";

type GetIntegrationsDirectCdiSourcesArgs = [] | [operatorSafe: boolean];

export const getIntegrationsDirectCdiSources = reactQueryFetcherAdapter<
  typeof integrationsDirectCdiSources,
  readonly [
    rootKey: RootCacheKey<typeof integrationsDirectCdiSources>,
    ...originalKey: GetIntegrationsDirectCdiSourcesArgs,
  ],
  GetIntegrationsDirectCdiSourcesArgs,
  CDISource[]
>(
  integrationsDirectCdiSources,
  (signal: AbortSignal, ...[operatorSafe]: GetIntegrationsDirectCdiSourcesArgs): Promise<CDISource[]> => {
    return fetch("/integrations/direct/cdi/sources", "GET", { operator_safe: operatorSafe }, { signal });
  },
  isCdiSourcesResult
);
